import { UserApi } from './authentication/api/UserApi';
import { AuthenticationService } from './authentication/service/AuthenticationService';
import { AuthenticationCheckService } from './authentication/service/AuthenticationCheckService';
import { HistoryApi } from './history/api/HistoryApi';
import { HistoryService } from './history/service/HistoryService';
import { LocalityApi } from './locality/api/LocalityApi';
import { LocalityService} from './locality/service/LocalityService';
import { HeaderController } from './header/controller/HeaderController';
import { SystemErrorController } from './error/controller/SystemErrorController';
import { ConfirmDlgController } from './extends_fw/controller/ConfirmDlgController';
import { NoticeDlgController } from './extends_fw/controller/NoticeDlgController';
import { CommonConst } from './CommonConst';
import { PjInjectProxy } from './extends_fw/PjInjectProxy';
import { PjInjectProxyImpl } from './extends_fw/PjInjectProxyImpl';

import { SharedService } from './extends_fw/controller/PjBaseController';

/**
 * 共通部品のコンポーネントを登録する
 * @param {ng.IModule} angularModule AngularJSのモジュール
 */
export function init(angularModule: ng.IModule): void {
    angularModule
        .factory('userApi', ($http: ng.IHttpService, $httpParamSerializer?: ng.IHttpParamSerializer): UserApi => {
            return new UserApi($http, $httpParamSerializer, CommonConst.SERVER_PATH);
        })
        .factory('historyApi', ($http: ng.IHttpService, $httpParamSerializer?: ng.IHttpParamSerializer): HistoryApi => {
            return new HistoryApi($http, $httpParamSerializer, CommonConst.SERVER_PATH);
        })
        .factory('localityApi', ($http: ng.IHttpService, $httpParamSerializer?: ng.IHttpParamSerializer): LocalityApi => {
            return new LocalityApi($http, $httpParamSerializer, CommonConst.SERVER_PATH);
        })
        .service('authenticationService', AuthenticationService)
        .service('authenticationCheckService', AuthenticationCheckService)
        .service('historyService', HistoryService)
        .service('localityService', LocalityService)
        .service('pjInjectProxy', PjInjectProxyImpl)
        .service('sharedService', SharedService)
        .controller('SystemErrorController', SystemErrorController)
        .controller('HeaderController', HeaderController)
        .controller('ConfirmDlgController', ConfirmDlgController)
        .controller('NoticeDlgController', NoticeDlgController);
}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/common/init.ts
 **/